export function problemDetailMessage(body: string): string | null {
  if (!body) return null;
  let parsed: unknown;
  try {
    parsed = JSON.parse(body);
  } catch {
    return body;
  }
  if (typeof parsed === 'string') return parsed || null;
  const problem = parsed as { detail?: unknown; title?: unknown } | null;
  const detail = typeof problem?.detail === 'string' ? problem.detail : null;
  const title = typeof problem?.title === 'string' ? problem.title : null;
  return detail || title;
}

/**
 * A ProblemDetails the generated client threw as an OBJECT rather than inside a SwaggerException.
 *
 * NSwag emits a typed branch for every error response an endpoint declares: it builds the body with
 * `ProblemDetails.fromJS(...)` and hands it to `throwException`, which throws that object and never
 * constructs a SwaggerException. Anything keyed on SwaggerException alone therefore loses the
 * server's sentence for exactly the responses the server bothered to document.
 *
 * Duck-typed rather than `instanceof ProblemDetails`: NSwag generates a separate class per declared
 * response schema, and they all carry these same fields.
 */
export function problemObjectMessage(err: unknown, statuses: readonly number[]): string | null {
  if (typeof err !== 'object' || err === null) return null;
  const problem = err as { status?: unknown; detail?: unknown; title?: unknown };
  // Status-gated like the SwaggerException path: a body without one is not something to show a user.
  if (typeof problem.status !== 'number' || !statuses.includes(problem.status)) return null;
  const detail = typeof problem.detail === 'string' ? problem.detail : null;
  const title = typeof problem.title === 'string' ? problem.title : null;
  return detail || title;
}
